/* eslint-disable max-len */
/* eslint-disable react/jsx-closing-bracket-location */
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import React, { Component } from 'react';
import Swal from 'sweetalert2';

import { Select } from 'antd';
import { withTranslation } from 'react-i18next';
import { GetFormat } from '../../AppUtil/AppUtil';
import Loader from '../Common/Loader';
import BaseGrid from './UpdateLoanGrids/BaseGrid';
import HeaderGrid from './UpdateLoanGrids/GridForHeader';
import { hot } from 'react-hot-loader';

const APP_IMAGES = window.AppConfig.APP_IMAGES;

class ForgiveAndReduce extends Component {
	constructor(props) {
		super(props);

		this.state = {
			id: ''
		};
	}

	genrateButton = (name, action) => {
		return (
			<Grid className="no-shadow" container id="reduce-width" justify="center" spacing={2}>
				<Grid id="shadow-round" item sm={8} spacing={2} xs={12}>
					<Button
						aria-label="add"
						className="back-btn-large-review btn-green"
						fullWidth
						onClick={action}
						// style={{ backgroundColor: 'darkblue', color: 'white' }}
						type="submit"
						variant="extended">
						{this.props.t(name)}
					</Button>
				</Grid>
			</Grid>
		);
	};

	toastWhenForgiveAndreduce = due_date => {
		if (this.state.id) {
			// If state.id exists, find the matching installment and get its date
			const matchingInstallment = this.filteredDueInstallments().find(
				installment => installment.id === this.state.id
			);

			if (matchingInstallment) {
				due_date = GetFormat(matchingInstallment.installment_date);
			}
		} else if (this.filteredDueInstallments().length > 0) {
			// If state.id doesn't exist, use the date from the first installment
			due_date = GetFormat(this.filteredDueInstallments()[0]?.installment_date);
		}

		Swal.fire({
			title: this.props.t('sweetalert_title.are_you_sure_forgive_payment', {
				due_date: GetFormat(due_date)
			}),
			icon: 'warning',
			allowOutsideClick: false,
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			confirmButtonText: this.props.t('buttons.yes'),
			customClass: 'otp_message_success'
		}).then(result => {
			if (result.value) {
				this.props.paymentAction(
					'FORGIVE_PAYMENT',
					this.forgiveAndReduce,
					this.toastSomethingWentWrong,
					this.state.id || this.filteredDueInstallments()[0]?.id
				);
			}
		});
	};

	forgiveAndReduce = () => {
		Swal.fire({
			animation: false,
			title: this.props.t('label.success'),
			text: this.props.t('app_message.you_have_successfully_forgiven_the_current_installment'),
			icon: 'success',
			allowOutsideClick: false,
			customClass: 'otp_message_success'
		});
	};

	toastSomethingWentWrong = () => {
		Swal.fire({
			title: this.props.t('sweetalert_title.error'),
			text: this.props.t('error_message.something_went_wrong'),
			imageUrl: 'https://cdn-icons-png.flaticon.com/512/5219/5219070.png',
			imageAlt: 'Custom Image',
			allowOutsideClick: false,
			// icon: 'error',
			confirmButtonText: this.props.t('buttons.try_again'),
			customClass: 'otp_message_success'
		});
	};

	generateReduceAndForgiveTxt = message => {
		return this.props.t(message);
	};

	nextPaymentDueTxt = (message, due_date) => {
		return this.props.t(message, { due_date: GetFormat(due_date) });
	};

	filteredDueInstallments = () => {
		return this.props.loanObject.installments?.filter(m => m.state === 'DUE');
	};

	getMessages = () => {
		return 'app_message.forgiving_the_first_due_on_and_reducing_amount';
	};

	render() {
		const { t } = this.props;

		const options = this.filteredDueInstallments().map(m => ({
			value: GetFormat(m.installment_date),
			label: GetFormat(m.installment_date)
		}));

		return (
			<section>
				<BaseGrid>
					<HeaderGrid>
						<img
							alt="Invite"
							className="img-reponsive"
							src={APP_IMAGES.FORGIVE_REDUCE}
							style={{ maxWidth: '100%', maxHeight: 'initial' }}
						/>
						<h4 className="text-center">{t('label.forgive_payment_and_reduce_loan')}</h4>
					</HeaderGrid>

					<Grid className="no-shadow" container id="reduce-width" justify="center" spacing={2}>
						<Grid id="shadow-round" item sm={8} spacing={2} xs={12}>
							{this.filteredDueInstallments().length > 1 ? (
								<>
									<p className="text-center">
										{this.generateReduceAndForgiveTxt(this.getMessages())}
									</p>
									<Select
										onChange={value => {
											const installment = this.filteredDueInstallments().filter(
												m => GetFormat(m.installment_date) === value
											);

											this.setState({ id: installment[0]?.id });
										}}
										options={options}
										placeholder="List Of Due Dates"
										style={{
											width: '100%',
											marginBottom: '100px'
										}}
									/>
								</>
							) : (
								<p className="text-center">
									{this.nextPaymentDueTxt(
										'app_message.forgiving_the_next_payment_due_on_and_reducing_amount',
										this.filteredDueInstallments()[0]?.installment_date
									)}
								</p>
							)}
						</Grid>
					</Grid>
					{this.genrateButton('buttons.confirm', () =>
						this.toastWhenForgiveAndreduce(this.filteredDueInstallments()[0]?.installment_date)
					)}
					<Grid className="no-shadow" container id="reduce-width" justify="center" spacing={2}>
						<Grid id="shadow-round" item sm={8} spacing={2} xs={12} />
					</Grid>
					{this.genrateButton('buttons.cancel', this.props.onBack)}
				</BaseGrid>
				{this.props.isLoading ? <Loader /> : ''}
			</section>
		);
	}
}

export default hot(module)(withTranslation()(ForgiveAndReduce));
